module.exports = __webpack_public_path__ + "static/media/s4g_bg.ffe8dd75.jpg";